import { string } from 'prop-types';
import GiftCard1 from 'components/GiftCard1';
import { GC_1 } from 'utils/constants/BackgroundId';
import * as styles from './styles/styles.module.scss';

const GiftCard = ({ backgroundId, classes }) => {
  if (backgroundId === GC_1) {
    return <GiftCard1 />;
  }

  // I think this is better than writing a bunch of import statements
  /* eslint-disable global-require, import/no-dynamic-require */
  const background = `url(${require(`./${backgroundId}.jpg`)})`;

  return <div style={{ background }} className={`${styles.cardContainer} ${classes}`} />;
};

GiftCard.propTypes = {
  backgroundId: string.isRequired,
  classes: string
};

GiftCard.defaultProps = {
  classes: ''
};

export default GiftCard;
